export enum AlertSeverity {
  Success = "success",
  Error = "error",
  Info = "info",
}

export enum AlertAction {
  Attach = "attach",
  Attached = "attached",
  Remove = "remove",
  Removed = "removed",
  Create = "create",
  Created = "created",
  Rename = "rename",
  Renamed = "renamed",
  Update = "update",
  Updated = "updated",
  Delete = "delete",
  Deleted = "deleted",
}
